import axios from 'axios';
import { myBizmatesApiBaseUrl, myStageApiBaseUrl, myStageCmsApiBaseUrl, bizmatesWordbookApiBaseUrl, bizmatesSiteBaseUrl } from '@/utils/constants';
import logger from '@/modules/Logger';
const isCmsPreview = window.location.href.indexOf("/cms-preview/") > -1;
class BizmatesApi {
  constructor(baseUrl) {
    this.apiBaseUrl = baseUrl;
  }

  getCmsParameters() {
    let urlString = window.location.href;
    let paramString = urlString.split('?')[1];
    let queryString = new URLSearchParams(paramString);
    let params = {};
    for(let pair of queryString.entries()) {
      params[pair[0]] = pair[1];
    }
    return params;
  }

  async get(apiSubUrl, options, onRespnse, onError) {
    if (!this.apiBaseUrl) {
      logger.error('Base URL for Bizmates API is not set.', { operation: 'api:get', result: -2,event_type:41 });
    }
    if (typeof onError !== 'function') {
      onError = error => {
        logger.error('API request to ' + apiSubUrl + ' failed: ', error, { operation: 'api:get',event_type:42 });
        return Promise.reject(error);
      };
    }

    const url = this.apiBaseUrl + '/' + apiSubUrl;
    logger.info('Attempting API request to: ' + url, { operation: 'api:get' });
    if (isCmsPreview) {
      options.headers = { 'cms-preview-token': this.getCmsParameters().token };
    }
    await axios
      .get(url, options)
      .then(onRespnse)
      .catch(onError);
  }

  async post(apiSubUrl, params, options, onRespnse, onError) {
    if (!this.apiBaseUrl) {
      logger.error('Base URL for Bizmates API is not set.',{event_type:41});
    }

    if (typeof onError !== 'function') {
      onError = error => {
        logger.error('API request to ' + apiSubUrl + ' failed: ', {error, event_type:42});
        return Promise.reject(error);
      };
    }

    const url = this.apiBaseUrl + '/' + apiSubUrl;
    logger.info('Attempting API request to: ' + url);
    if (isCmsPreview) {
      options.headers = { 'cms-preview-token': this.getCmsParameters().token };
    }
    return await axios
      .post(url, params, options)
      .then(onRespnse)
      .catch(onError);
  }

  async put(apiSubUrl, data, options, onRespnse, onError) {
    if (!this.apiBaseUrl) {
      logger.error('Base URL for Bizmates API is not set.',{event_type:41});
    }
    if (typeof onError !== 'function') {
      onError = error => {
        logger.error('API request to ' + apiSubUrl + ' failed: ', {error, event_type:42});
        return Promise.reject(error);
      };
    }

    const url = this.apiBaseUrl + '/' + apiSubUrl;
    logger.info('Attempting API request to: ' + url);
    await axios
      .put(url, data, options)
      .then(onRespnse)
      .catch(onError);
  }

  async delete(apiSubUrl, params, onRespnse, onError) {
    if (!this.apiBaseUrl) {
      logger.error('Base URL for Bizmates API is not set.', {event_type:41});
    }
    if (typeof onError !== 'function') {
      onError = error => {
        logger.error('API request to ' + apiSubUrl + ' failed: ', {error,event_type:42});
        return Promise.reject(error);
      };
    }

    const url = this.apiBaseUrl + '/' + apiSubUrl;
    logger.info('Attempting API request to: ' + url);
    await axios
      .request({ url, params, method: 'delete' })
      .then(onRespnse)
      .catch(onError);
  }

  async deleteBodyRequest(apiSubUrl, data, onRespnse, onError) {
    if (!this.apiBaseUrl) {
      logger.error('Base URL for Bizmates API is not set.',{event_type:41});
    }
    if (typeof onError !== 'function') {
      onError = error => {
        logger.error('API request to ' + apiSubUrl + ' failed: ', {error,event_type:42});
        return Promise.reject(error);
      };
    }

    const url = this.apiBaseUrl + '/' + apiSubUrl;
    logger.info('Attempting API request to: ' + url);
    await axios
      .request({ url, data, method: 'delete' })
      .then(onRespnse)
      .catch(onError);
  }

  /**
   * Used in bizTransport sent log to bizmates.jp to sent logger when lesson-ongoing
   * Use console.log to avoid output loop by itself
   */
  async postLog(params, options, onRespnse, onError) {
    if (!this.apiBaseUrl) {
      console.log('Base URL for Bizmates API is not set.');
    }
    if (typeof onError !== 'function') {
      onError = error => {
        console.log('API request to lesson/log failed: ', error);
        return Promise.reject(error);
      };
    }

    const path = options.isTrial ? 'sales' : 'lesson';
    const url = this.apiBaseUrl + `/${path}/log`;
    await axios
      .post(url, params, options)
      .then(onRespnse)
      .catch(onError);
  }

  async ping() {
    if (!this.apiBaseUrl) {
      logger.error('Base URL for Bizmates API is not set.', { operation: 'api:get', result: -2,event_type:41 });
    }
    await axios.get(this.apiBaseUrl);
  }
}

let bizmatesApi = new BizmatesApi(myStageApiBaseUrl);
// If URL has cms-preview then use the CMS API
bizmatesApi = isCmsPreview ? new BizmatesApi(myStageCmsApiBaseUrl) : bizmatesApi;
let bizmatesBaseApi = new BizmatesApi(myBizmatesApiBaseUrl);
let bizmatesBase = new BizmatesApi(`${bizmatesSiteBaseUrl}/MyBizmates`);
let bizmatesWordbookApi = new BizmatesApi(bizmatesWordbookApiBaseUrl);

export { bizmatesApi, bizmatesWordbookApi, bizmatesBaseApi, bizmatesBase };
